import { AlertTriangle, ArrowRight, BriefcaseBusiness } from "lucide-react";
import { Link } from "react-router-dom";

import AppEmptyState from "@/components/ui/AppEmptyState";
import { Button } from "@/components/ui/button";

const TONE_CLASSNAME = {
  warning: "border-amber-500/20 bg-amber-500/10 text-amber-100",
  danger: "border-red-500/20 bg-red-500/10 text-red-100",
  info: "border-lenvia-blue/20 bg-lenvia-blue/10 text-slate-100",
};

const BusinessAlerts = ({ alerts = [] }) => (
  <section
    className="min-w-0 rounded-3xl border border-white/10 glass p-6"
    data-testid="pilotage-business-alerts"
  >
    <div className="min-w-0">
      <h2 className="flex items-center gap-2 text-lg font-semibold text-white">
        <AlertTriangle className="h-5 w-5 text-lenvia-blue" />
        Alertes business
      </h2>
      <p className="mt-1 text-sm text-slate-400">
        Signaux d'action rapides pour anticiper staffing, renouvellements et marge.
      </p>
    </div>

    <div className="mt-5 min-w-0">
      {alerts.length === 0 ? (
        <AppEmptyState
          title="Aucune alerte"
          description="Aucun signal critique détecté sur les données actuellement chargées."
          className="p-6"
          testId="pilotage-business-alerts-empty"
        />
      ) : (
        <div className="space-y-3">
          {alerts.map((alert) => (
            <div
              key={alert.id}
              className={`flex min-w-0 flex-col gap-3 rounded-3xl border p-4 md:flex-row md:items-center md:justify-between ${TONE_CLASSNAME[alert.tone] || TONE_CLASSNAME.info}`}
            >
              <div className="min-w-0">
                <p className="font-semibold">{alert.title}</p>
                <p className="mt-1 text-sm opacity-80">{alert.description}</p>
              </div>

              <Button
                asChild
                size="sm"
                variant="outline"
                className="h-8 shrink-0 border-white/10 bg-transparent text-xs text-white"
              >
                <Link to={alert.to}>
                  <BriefcaseBusiness className="mr-1.5 h-3.5 w-3.5" />
                  {alert.linkLabel || "Voir"}
                  <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
                </Link>
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  </section>
);

export default BusinessAlerts;
